import classNames from "classnames";
import { Controller } from "react-hook-form";
import ReactSelect from "react-select";

const Select = ({ control, data, id, disabled = false }) => {
	return (
		<Controller
			control={control}
			name={id}
			render={({ field: { onChange, value, ref } }) => (
				<ReactSelect
					id={id}
					ref={ref}
					value={data.find((c) => c.value === value)}
					onChange={(val) => {
						onChange(val.value);
					}}
					options={data}
					isDisabled={disabled}
					unstyled
					classNames={{
						control: ({ isDisabled, isFocused }) =>
							classNames(
								!isDisabled && isFocused && "shadow-black",
								isFocused && "shadow-[0_0_0_1px] shadow-black",
								isFocused && "ring-black border-black",
								"border border-black text-gray-900 rounded-xl p-3",
							),
						option: ({ isDisabled, isFocused, isSelected }) =>
							classNames(
								isSelected && "bg-gray-100",
								!isSelected && isFocused && "hover:bg-gray-200",
								!isDisabled && isSelected && "bg-gray-100",
								!isDisabled && !isSelected && "bg-white",
								"px-3 py-2 border-2",
							),
						noOptionsMessage: () => classNames("bg-gray-100 p-3"),
						placeholder: () => classNames("text-gray-400"),
					}}
				/>
			)}
		/>
	);
};

export default Select;
